import React from "react";
import { ColumnsType } from "antd/es/table";
import { TFunction } from "i18next";

enum EmployeeTrainingStatus {
  NOT_STARTED = "NOT_STARTED",
  EXPIRED_CERTIFICATION = "EXPIRED_CERTIFICATION",
  IN_PROGRESS = "IN_PROGRESS",
  NOT_FINISHED = "NOT_FINISHED",
  NOT_PROVIDER = "NOT_PROVIDER",
  COMPLETED = "COMPLETED",
}

const getStatusStyle = (status: string): React.CSSProperties => {
  if (
    status === EmployeeTrainingStatus.NOT_STARTED ||
    status === EmployeeTrainingStatus.EXPIRED_CERTIFICATION
  ) {
    return { color: "#DE0E0E", fontWeight: "bold" };
  }
  if (
    status === EmployeeTrainingStatus.NOT_FINISHED ||
    status === EmployeeTrainingStatus.IN_PROGRESS
  ) {
    return { color: "#EA8805", fontWeight: "bold" };
  }
  if (status === EmployeeTrainingStatus.COMPLETED) {
    return { color: "#55AF46", fontWeight: "bold" };
  }
  return {};
};

export const getEmployeeColumns = (
  t: TFunction,
  options: string[],
  redirectToUserProfile: (id: string) => () => void
): ColumnsType<any> =>
  options.map((option) => {
    const baseColumn = {
      title: t(`employeeTraining.${option}`),
      dataIndex: option,
      key: option,
      render: (value: any, record: any) => {
        if (
          [
            "basicLevelStatus",
            "standardLevelStatus",
            "certificationLevelStatus",
          ].includes(option)
        ) {
          const map = {
            basicLevelStatus: record.isHideBasicStatus,
            standardLevelStatus: record.isHideStandardStatus,
            certificationLevelStatus: record.isHideCertificationStatus,
          };
          if (map[option]) return null;
          return (
            <span style={getStatusStyle(value)}>
              {value
                ? t(`employeeTraining.${value}`, { defaultValue: value })
                : value}
            </span>
          );
        }
        if (option === "fio") {
          return (
            <a
              onClick={redirectToUserProfile(record.employeeId)}
              target="_blank"
              rel="noopener noreferrer"
            >
              {record.surname} {record.name} {record.middleName}
            </a>
          );
        }
        return <span>{value}</span>;
      },
    };
    return baseColumn;
  });
